module.exports = __webpack_public_path__ + "static/img/1.7ef6c71.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/product/1.jpg
// module id = xrSa
// module chunks = 2